export default __webpack_public_path__ + "static/media/logo-vertical.33eaf336.jpg";